import { createConsumer } from '@rails/actioncable';
import * as connectionActions from '../state/modules/connection/actions';

let actionCable;

const getActionCable = () => {
  actionCable = actionCable || createConsumer();
  return actionCable;
};

export const createWebsocketListener = ({
  dispatch,
  connectHandler,
  receivedHandler,
  fallbackPoller,
  fallbackPollerInterval
}) => {
  let poller = null;
  let disconnectTime = null;

  // a disconnection should wait at least this long before we are going to call
  // the API
  const MIN_DISCONNECT_TIME_BEFORE_API_CALL = 60 * 1000;

  // Wait between MIN and MAX seconds before making API call
  const MIN_WAIT_TIME_BEFORE_API_CALL = 30 * 1000;
  const MAX_WAIT_TIME_BEFORE_API_CALL = 120 * 1000;

  const WAIT_TIME_BEFORE_POLLING_START = 15 * 1000;

  return {
    connected: () => {
      connectHandler && connectHandler();
      dispatch(connectionActions.connected());

      if (poller) {
        // reconnected: cancel polling and get fresh data
        clearInterval(poller);
        // if disconnected for more than 60 seconds, fire off an API call
        if (Date.now() - disconnectTime > MIN_DISCONNECT_TIME_BEFORE_API_CALL) {
          // avoid thundering herd: randomly wait between 30 and 120 seconds
          setTimeout(
            fallbackPoller,
            MIN_WAIT_TIME_BEFORE_API_CALL +
              (MAX_WAIT_TIME_BEFORE_API_CALL - MIN_WAIT_TIME_BEFORE_API_CALL) * Math.random()
          );
        } else {
          console.log('Disconnected time too short. Not calling API');
        }
      }
    },
    disconnected: () => {
      if (fallbackPoller) {
        disconnectTime = Date.now();
        const delayedFallbackPoller = () => {
          // wait before making the first polling call
          if (Date.now() - disconnectTime > WAIT_TIME_BEFORE_POLLING_START) {
            fallbackPoller();
          }
        };
        poller = setInterval(delayedFallbackPoller, fallbackPollerInterval);
      }
      dispatch(connectionActions.disconnected());
    },
    received: data => {
      if (data === 'PING') return;
      receivedHandler && receivedHandler(data);
    }
  };
};

export default getActionCable;
